import { useMemo } from 'react';
import { Combobox } from '../../../../../../commonComponents/Combobox/Combobox';
import { useDSOList } from './hooks/useDSOList';

export const DsoFilter = ({
  filters,
  handleFilterChanged,
  label = 'DSO:',
  placeholder = 'All',
}) => {
  const { data, hasNextPage, fetchNextPage } = useDSOList();

  const options = useMemo(
    () =>
      data.map((dso) => ({
        label: dso.name,
        value: dso.id,
      })),
    [data],
  );

  return (
    <Combobox
      hasReachMax={!hasNextPage}
      isAutoApply
      isPaged
      label={label}
      options={options}
      placeholder={placeholder}
      values={options?.find((it) => it.value === filters.dsoId) || []}
      onChange={(values) => {
        handleFilterChanged('dsoId', values?.value, values?.label);
      }}
      onNextPage={fetchNextPage}
    />
  );
};
